import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { Feature } from "geojson";

export const TOO_MANY_FEATURES_THRESHOLD = 1_000;

/**
 * Adds a draw feature to the drawControl and sets the feature state to isEditing for the underlying
 * vector feature (which styles use to hide the feature behind the draw feature)
 */
export function addDrawFeature(this: MapboxDraw.DrawCustomModeThis, feature: Feature): MapboxDraw.DrawFeature {
  const existingFeature = feature.id ? this.getFeature(feature.id) : null;
  const drawFeature = existingFeature || this.newFeature(feature);
  const featureId = drawFeature.id;

  // This hides the original feature on the map by setting a feature state that the style
  // can use to conditionally hide the feature
  if (this._ctx.options.selectableSource) {
    this.map?.setFeatureState(
      { id: featureId, source: this._ctx.options.selectableSource, sourceLayer: this._ctx.options.selectableSourceLayer },
      { isEditing: true }
    );
  }

  if (!existingFeature) this.addFeature(drawFeature);

  return drawFeature;
}
